import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {catchError} from "rxjs/internal/operators/catchError";
import {throwError} from "rxjs/internal/observable/throwError";
import {NavCounts} from "../models/NavCounts";
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {SelectedAccountService} from "./selected-account.service";
import { Subscription } from 'rxjs/internal/Subscription';
import {UserGuide} from "../../layouts/secure/administration/user-guides/models/UserGuide";

@Injectable({
    providedIn: 'root'
})
export class NavServiceService {

    constructor(private _http: HttpClient, public selectedAccounts: SelectedAccountService) { }

    private _isNavExpanded: boolean = false;

    private _subscription: Subscription;

    public get isNavExpanded() {
        return this._isNavExpanded;
    }

    public set isNavExpanded(value) {
        this._isNavExpanded = value;
    }

    private _isDropdownExpanded: boolean = false;

    public get isDropdownExpanded() {
        return this._isDropdownExpanded;
    }

    public set isDropdownExpanded(value) {
        this._isDropdownExpanded = value;
    }

    public toggleNav(value: boolean = null) {
        this._isDropdownExpanded = false;
        if (value !== null) {
            this._isNavExpanded = value;
        } else {
            this._isNavExpanded = !this._isNavExpanded;
        }
    }

    public toggleDropdown(value: boolean = null) {
        if (value !== null) {
            this._isDropdownExpanded = value;
        } else {
            this._isDropdownExpanded = !this._isDropdownExpanded;
        }
    }
    
    public navCounts = new NavCounts();


    public getNavCounts(distributorId: number, groupId: number, siteId: number, accountId: number, propertyId: number, businessActivityId: number) {
       return this._http.get<NavCounts>(`api/NavMenu/GetNavCounts?distributorId=${distributorId}&groupId=${groupId}&siteId=${siteId}&accountId=${accountId}&propertyId=${propertyId}&businessActivityId=${businessActivityId}`).pipe(
            catchError(this.handleError)
        );
    }

    public async updateNavCounts() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
        this._subscription = this.getNavCounts(this.selectedAccounts.distributorId, this.selectedAccounts.groupId, this.selectedAccounts.siteId, this.selectedAccounts.accountId, this.selectedAccounts.propertyId, this.selectedAccounts.businessActivityId).subscribe((data => {
            this.navCounts = data;
        }).bind(this));
    }
    
    public userGuides: UserGuide[];

    private handleError(error: Response) {
        return throwError(error.statusText);
    }
}
